var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C37.7025 5.15406e-07 48 10.2975 48 23V25C48 37.7025 37.7025 48 25 48H23C10.2975 48 0 37.7025 0 25V23C5.1544e-07 10.2975 10.2975 0 23 0H25Z",
    fill: "#FFE8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 35.6668V29.8335M15.25 18.1668V12.3335M12.3333 15.2502H18.1667M12.3333 32.7502H18.1667M25.1667 13.5002L23.1435 18.7605C22.8145 19.6159 22.6499 20.0437 22.3941 20.4034C22.1674 20.7223 21.8888 21.0009 21.5699 21.2276C21.2102 21.4834 20.7824 21.6479 19.927 21.977L14.6667 24.0002L19.927 26.0234C20.7825 26.3524 21.2102 26.5169 21.5699 26.7727C21.8888 26.9994 22.1674 27.278 22.3941 27.5969C22.6499 27.9567 22.8145 28.3844 23.1435 29.2398L25.1667 34.5002L27.1899 29.2398C27.5189 28.3844 27.6834 27.9567 27.9392 27.5969C28.166 27.278 28.4445 26.9994 28.7634 26.7727C29.1232 26.5169 29.5509 26.3524 30.4063 26.0234L35.6667 24.0002L30.4063 21.977C29.5509 21.6479 29.1232 21.4834 28.7634 21.2276C28.4445 21.0009 28.166 20.7223 27.9392 20.4034C27.6834 20.0437 27.5189 19.6159 27.1899 18.7605L25.1667 13.5002Z",
    stroke: "#9298A4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSquare);
export default __webpack_public_path__ + "static/media/star-square.6363228e85e5ef81e609225c38dbab4a.svg";
export { ForwardRef as ReactComponent };